import React from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import Style from './index.css';
import { Player } from '@ifeng-fe/three_terminal/es/pc/video';

const VideoMask = (props) => {
    const { visible, videoInfo, onChangeVisible } = props;

    if (!visible) {
        return null;
    }

    const closeMask = () => {
        window.videoOrderList = undefined;
        onChangeVisible(false);
    };

    const getWidthHeight = () => {
        const { innerWidth, innerHeight } = window;

        if (innerHeight <= (innerWidth * 9) / 16) {
            return {
                width: (innerHeight * 0.8 * 16) / 9,
                height: innerHeight * 0.8,
            };
        } else {
            return {
                width: innerWidth * 0.8,
                height: (innerWidth * 0.8 * 9) / 16,
            };
        }
    };

    return (
        <div className={Style.mask} id="mask1">
            <div className={Style.video_wp} style={{ width: `${getWidthHeight().width}px`, height: `${getWidthHeight().height}px` }}>
                <Player
                    key={videoInfo.guid}
                    videoConfig={{
                        videoPlayUrl: videoInfo.url,
                        duration: Number(videoInfo.duration),
                        vid: videoInfo.guid,
                    }}
                    playermsg={{
                        subject: '2023dfjpt',
                        adType: 2,
                        width: getWidthHeight().width,
                        height: getWidthHeight().height,
                        autoPlay: true,
                        controls: true,
                    }}
                />
                <div className={Style.close} onClick={closeMask}>
                    <img src="https://x0.ifengimg.com/ucms/2021_34/CB5E1E455F4CF99D965377482E9FF3AC0FD608CD_size1_w45_h45.png" alt="" />
                </div>
            </div>
        </div>
    );
};

VideoMask.propTypes = {
    visible: PropTypes.bool,
    videoInfo: PropTypes.object,
    onChangeVisible: PropTypes.func,
};

export default errorBoundary(VideoMask);
